import { Link } from "react-router-dom";
import { Cross, MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";

const COURSE_LINKS = [
  { label: "Nursery Teacher Training", to: "/courses" },
  { label: "Primary Teacher Training", to: "/courses" },
  { label: "Spoken English & Grammar", to: "/courses" },
  { label: "IELTS Coaching", to: "/courses" },
  { label: "Vocational Programs", to: "/courses" },
  { label: "Support Us — Donate", to: "/donate" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="grain-overlay relative overflow-hidden bg-forest-deep text-cream">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-20 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold text-forest-deep">
                <Cross className="h-5 w-5" />
              </span>
              <span className="font-serif text-2xl font-bold">St. Mary's Charitable Trust</span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/70">
              A Christian charitable trust in Mandya, Karnataka — transforming lives through quality teacher education,
              language mastery and vocational skills for sustainable livelihoods.
            </p>
            <p className="mt-6 font-serif text-lg italic text-gold/90">
              "Let all that you do be done in love." — 1 Corinthians 16:14
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Programs</h4>
            <ul className="mt-5 space-y-3">
              {COURSE_LINKS.map((c) => (
                <li key={c.label}>
                  <Link to={c.to} data-testid={`footer-course-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-cream/70 transition-colors hover:text-gold">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Visit Us</h4>
            <ul className="mt-5 space-y-4 text-sm text-cream/70">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-terracotta" />
                <span>Old Post Office, 1st Floor, near Water Tank, Guthalu Road, Mandya — 571403, Karnataka</span>
              </li>
              <li className="flex gap-3">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-terracotta" />
                <a href="tel:+917975094721" data-testid="footer-phone-link" className="hover:text-gold">+91 79750 94721</a>
              </li>
              <li className="flex gap-3">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-terracotta" />
                <a href="mailto:magdaleenajoy@gmail.com" data-testid="footer-email-link" className="hover:text-gold">magdaleenajoy@gmail.com</a>
              </li>
              <li className="flex gap-3">
                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-terracotta" />
                <span>Mon – Sat · 9:00 AM – 6:00 PM</span>
              </li>
            </ul>
            <a
              href="https://wa.me/917975094721"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-button"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-gold/40 px-5 py-2.5 font-display text-sm text-gold transition-colors hover:bg-gold hover:text-forest-deep"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp Us
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-cream/10 pt-8 sm:flex-row">
          <p className="text-xs text-cream/50">© {new Date().getFullYear()} St. Mary's Charitable Trust, Mandya. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-cream/40 transition-colors hover:text-gold">
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
